import { asCreator, withCallbacks } from '../../../../lib/utils';
import { compose } from '../../../../utils/functions';
import { actionTypes } from '../../reducers/notificationsReducer';

export const dismissPendingHouseholdNotification = compose(
  withCallbacks,
  asCreator((args: any) => ({
    type: actionTypes.DISMISS_PENDING_HOUSEHOLD,
    payload: args,
  }))
);
